export default __webpack_public_path__ + "static/media/s7.417d840e.jpg";